import React, { CSSProperties, FC, useEffect, useState } from "react";
import { _axios } from "../../../api";
import CloseIcon from "../../icons/CloseIcon";
import { useDetectClickOutside } from "react-detect-click-outside";
import { useDispatch, useSelector } from "react-redux";
import {
  getCustomProducts,
  getChoosenProductsForCustom,
  clearSetting,
} from "../../../features/logicBuilder/logicBuilder";
import { Widget } from "../../../widgetList/widgetList";
import { checkToken } from "../../../App";
import { RootState } from "../../../app/store";
import Cookies from "js-cookie";
import { setGlobalPopupElement } from "../../../features/popupSlice";
import CustomProductPopup from "../../CustomProductPopup";
import { adminTokenCookieName, envs } from "../../../utils/constants";
import classes from "./CustomProductPopup.module.css";
import { VideoItem } from "../../../types/video";

interface Props {
  choosenItem: Widget;
  sourceType: string;
}

const CustomBuilderForHalalflix: FC<Props> = ({ sourceType, choosenItem }) => {
  const choosenCustomProducts = choosenItem?.data?.setting?.custom || [];

  const ids: any[] = choosenItem?.data?.setting?.custom || [];
  const [text, setText] = useState<string>("");
  const [products, setProdcuts] = useState<any[]>([]);
  // const [allProducts, setAllProducts] = useState<any[]>()
  const [choosenProducts, setChoosenProducts] = useState<any[]>([]);
  const [show, setShow] = useState<boolean>(true);
  const [productIds, setProductIds] = useState<any[]>([]);

  const dispatch = useDispatch();

  useEffect(() => {
    //getAllProducts(ids)
    setChoosenProducts(choosenCustomProducts);
    setProductIds(ids);
    // dispatch(clearSetting());
    dispatch(getCustomProducts(choosenCustomProducts));
  }, [choosenItem]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
    const _text: string = e.target.value;
    getProducts(_text.trim());
  };

  const getProducts = async (_text: string) => {
    checkToken();
    await _axios
      .get(envs.frontendApiUrl + "product/storefront?search=" + _text, {
        headers: {
          Authorization: `Bearer ${Cookies.get(adminTokenCookieName)}`,
        },
      })
      .then((res) => {
        setProdcuts(res.data?.data);
        setShow(true);
      });
  };

  // const getAllProducts = async(ids: any) => {
  //   checkToken()
  //     const postData = {
  //         "productIds": ids,
  //     }
  //     const res = await _axios.post(`${process.env.REACT_APP_BASE_URL}catalog/product/frontend`, postData, { headers: {
  //       'Content-Type': 'application/json',
  //       "Authorization": `Bearer ${Cookies.get(adminTokenCookieName)}`
  //     }})
  //     setChoosenProducts(res.data)
  // }

  const handleChoosenProduct = (product: any) => {
    const _choosenProducts = [...choosenProducts];
    _choosenProducts.push(product);
    setChoosenProducts(_choosenProducts);

    // const ids: number[] = _choosenProducts.map(item => {
    //   return item.id
    // })

    // setProductIds(ids)

    // dispatch(getChoosenProductsForCustom(_choosenProducts))
    // dispatch(getCustomProducts(ids))
    dispatch(getCustomProducts(_choosenProducts));
    setText("");
  };

  const hideProductList = () => {
    setShow(false);
  };

  const handleRemoveProductId = (index: number) => {
    // const filteredProductIds = productIds.filter((_,i)=> i !== index)
    // setProductIds(filteredProductIds)
    const filteredProducts = choosenProducts.filter((_, i) => i !== index);
    setChoosenProducts(filteredProducts);
    dispatch(getCustomProducts(filteredProducts));
  };

  const ref = useDetectClickOutside({ onTriggered: hideProductList });

  return (
    <div className="mt-2">
      <div>
        {
          <div className="w-full my-4">
            {/* {
              choosenProducts.map((item: Widget, index: number) => {
                return (
                  <div key={index} className="relative h-auto flex items-center justify-center bg-white shadow-lg rounded-md mb-2 last:mb-4">
                    <div className='capitalize text-xs font-light tracking-wide p-3'>
                      <div className='mb-2'><span className='font-bold'>Product: </span>{item?.name}</div>
                      <div><span className='font-bold'>Sku: </span>{item?.monarchmart_sku}</div>
                    </div>
                    <div onClick={()=>handleRemoveProductId(index)} className='absolute -top-3 -right-3 bg-white text-red-500 rounded-full p-1 cursor-pointer shadow-lg'>
                      <CloseIcon />
                    </div>
                  </div>
                )
              })
            } */}
            <div className="relative h-auto flex items-center justify-center bg-white shadow-lg rounded-md mb-2 last:mb-4">
              <div className="capitalize text-xs font-light tracking-wide p-3">
                {choosenProducts.length > 0 ? (
                  <p>Total Videos: {choosenProducts.length}</p>
                ) : (
                  <p>No Videos Added</p>
                )}
              </div>
            </div>
          </div>
        }
      </div>
      <div>
        <button
          className="text-gray-500 px-3 py-2 rounded-md shadow-lg bg-gray-100 hover:bg-white w-full"
          onClick={(e) => {
            e.preventDefault();

            dispatch(
              setGlobalPopupElement(
                <CustomVideoPopup
                  initialProducts={choosenProducts}
                  onSetProducts={(products) => {
                    setChoosenProducts(products);
                  }}
                />
              )
            );
          }}
        >
          Manage Videos
        </button>
        {/* <input value={text} type="text" placeholder='search...'  onChange={handleOnChange}/> */}
        <div>
          {products?.length > 0 && show && (
            <div
              className="bg-white px-3 shadow-lg divide-y max-h-96 min-h-fit overflow-y-scroll"
              ref={ref}
            >
              {products?.map((product) => {
                return (
                  <div key={product.id}>
                    <div
                      className="flex flex-col items-center justify-between cursor-pointer py-2"
                      onClick={() => handleChoosenProduct(product)}
                    >
                      <div className="text-xs font-light w-full">
                        <span className="font-bold">Product:</span>{" "}
                        {product?.title}
                      </div>
                      {/* <div className="text-xs font-light w-full">
                        <span className="font-bold">Sku:</span>{" "}
                        {product?.monarchmart_sku}
                      </div> */}
                      <div className="text-xs font-light flex items-center w-full justify-start">
                        <span className="font-bold">Price:</span>
                        {product.discount_price ? (
                          <div>
                            <span className="text-gray-400 line-through mr-3">
                              &#2547;{product?.purchase_price}
                            </span>
                            <span className="text-red-500">
                              &#2547;{product?.discount_price}
                            </span>
                          </div>
                        ) : (
                          <div className="text-red-500">
                            {product.purchase_price}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const CustomBuilderV2 = ({
  custom = [],
  onUpdate,
}: {
  custom?: number[];
  onUpdate: (custom: number[]) => void;
}) => {
  const dispatch = useDispatch();
  const [choosenProducts, setChoosenProducts] = useState<any[]>(custom);

  const handleUpadte = () => {
    onUpdate(choosenProducts);
  };

  return (
    <div className="mt-2">
      <div>
        {
          <div className="w-full my-4">
            <div className="relative h-auto flex items-center justify-center bg-white shadow-lg rounded-md mb-2 last:mb-4">
              <div className="capitalize text-xs font-light tracking-wide p-3">
                {choosenProducts.length > 0 ? (
                  <p>Total products: {choosenProducts.length}</p>
                ) : (
                  <p>No products added</p>
                )}
              </div>
            </div>
          </div>
        }
      </div>
      <div>
        <button
          className="text-gray-500 px-3 py-2 rounded-md shadow-lg bg-gray-100 hover:bg-white w-full"
          onClick={(e) => {
            e.preventDefault();

            dispatch(
              setGlobalPopupElement(
                <CustomProductPopup
                  initialProducts={choosenProducts}
                  onSetProducts={(products) => {
                    setChoosenProducts(products);
                  }}
                />
              )
            );
          }}
        >
          Manage Products
        </button>
        {/* <input value={text} type="text" placeholder='search...'  onChange={handleOnChange}/> */}
      </div>

      <div className="mt-4">
        <button type="button" className="update_button" onClick={handleUpadte}>
          Update
        </button>
      </div>
    </div>
  );
};

export default CustomBuilderForHalalflix;

const CustomVideoPopup = ({
  initialProducts,
  onSetProducts = () => {},
  className,
  style,
}: {
  initialProducts?: VideoItem[];
  onSetProducts?: (products: VideoItem[]) => void;
  className?: string;
  style?: CSSProperties;
}) => {
  const dispatch = useDispatch();

  const [choosenProducts, setChoosenProducts] = useState<VideoItem[]>(
    initialProducts || []
  );
  const [text, setText] = useState<string>("");
  const [products, setProdcuts] = useState<any[]>([]);
  const [show, setShow] = useState<boolean>(true);

  const [showBulkPopup, setShowBulkPopup] = useState<boolean>(false);

  const classNames = [classes.CustomProductPopup, className];

  const handleRemoveProductId = (index: number) => {
    const filteredProducts = choosenProducts.filter((_, i) => i !== index);
    setChoosenProducts(filteredProducts);
    dispatch(getCustomProducts(filteredProducts as any[]));
    onSetProducts(filteredProducts);
  };

  const concatProductsUnique = (
    products: VideoItem[],
    newProducts: VideoItem[]
  ) => {
    const newProductsMap = new Map<string, VideoItem>();
    newProducts.forEach((product) => {
      newProductsMap.set(product.id + "", product);
    });

    const newProductsSet = new Set<string>();
    newProducts.forEach((product) => {
      newProductsSet.add(product.id + "");
    });

    const newProductsList = products.filter(
      (product) => !newProductsSet.has(product.id + "")
    );
    newProductsList.push(...newProducts);

    return newProductsList;
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
    const _text: string = e.target.value;
    getVideos(_text.trim());
  };

  const getVideos = async (_text: string) => {
    await _axios
      .get(envs.frontendApiUrl + "video/storefront?search=" + _text, {
        headers: {
          Authorization: `Bearer ${Cookies.get(adminTokenCookieName)}`,
        },
      })
      .then((res) => {
        setProdcuts(res.data?.data);
        setShow(true);
      });
  };

  const handleChoosenProduct = (product: VideoItem) => {
    const _choosenProducts = concatProductsUnique([product], choosenProducts);
    setChoosenProducts(_choosenProducts);

    dispatch(getCustomProducts(_choosenProducts as any[]));
    onSetProducts(_choosenProducts);
    setText("");
    setShow(false);
  };

  const concatProducts = (products: VideoItem[]) => {
    const _choosenProducts = concatProductsUnique(products, choosenProducts);
    setChoosenProducts(_choosenProducts);
    dispatch(getCustomProducts(_choosenProducts as any[]));
    onSetProducts(_choosenProducts);
    setText("");
  };

  const replaceProducts = (products: VideoItem[]) => {
    setChoosenProducts(products);
    dispatch(getCustomProducts(products as any[]));
    onSetProducts(products);
    setText("");
  };

  const hideProductList = () => {
    setShow(false);
  };

  const handlePopupClose = () => {
    dispatch(setGlobalPopupElement(null));
  };

  const ref = useDetectClickOutside({ onTriggered: hideProductList });

  return (
    <>
      <div
        className={classNames.join(" ") + `${showBulkPopup ? "!hidden" : ""}`}
        style={style}
      >
        <div
          className="absolute w-full h-full -z-10"
          onClick={handlePopupClose}
        ></div>

        <div className={classes.contents}>
          <div className={classes.top}>
            <div className={classes.left}>
              <input
                value={text}
                type="text"
                placeholder="Add custom videos..."
                onChange={handleOnChange}
              />
              <div className="absolute w-full top-full left-0 z-50">
                {products?.length > 0 && show && (
                  <div
                    className="bg-white px-3 shadow-lg divide-y max-h-96 min-h-fit overflow-y-auto"
                    ref={ref}
                  >
                    {products?.map((product) => {
                      return (
                        <div key={product.id}>
                          <div
                            className="flex items-center gap-4 cursor-pointer py-2"
                            onClick={() => handleChoosenProduct(product)}
                          >
                            <img
                              // src={`${
                              //   process.env.REACT_APP_SELLER_IMAGE_URL +
                              //   "upload" +
                              //   product?.videoThumbnail
                              // }`}
                              src={`${process.env.REACT_APP_SELLER_IMAGE_URL}upload/${product?.videoThumbnail}`}
                              alt=""
                              className="w-12 h-12 object-contain"
                            />
                            <div className="text">
                              <div className="text-xs font-light w-full">
                                <span className="font-bold">Product:</span>{" "}
                                {product?.title}
                              </div>
                              {/* <div className="text-xs font-light w-full">
                                <span className="font-bold">Sku:</span>{" "}
                                {product?.sku || product?.monarchmart_sku}
                              </div> */}
                              <div className="text-xs font-light flex items-center w-full justify-start">
                                {/* <span className='font-bold'>Price:</span>
                        {
                          product.discount_price ? <div>
                          <span className='text-gray-400 line-through mr-3'>	
                          &#2547;{product?.purchase_price}</span><span className='text-red-500'>	
                          &#2547;{product?.discount_price}</span></div> : <div className='text-red-500'>{product.purchase_price}</div>
                        } */}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            {/* <button
              onClick={() => setShowBulkPopup(true)}
              className="bg-orange-500 text-white px-3 py-1 rounded-md text-xs font-bold tracking-wide"
            >
              Add Bulk Videos
            </button> */}

            <button onClick={handlePopupClose} className={classes.closeButton}>
              <CloseIcon />
            </button>
          </div>

          <div className={classes.body}>
            <div className={classes.products}>
              {choosenProducts.map((item: VideoItem, index: number) => {
                return (
                  <div
                    key={index}
                    className="relative flex h-full items-center bg-white shadow-lg rounded-md mb-2 last:mb-4"
                  >
                    <div className={classes.productImage}>
                      <img
                        // src={
                        //   process.env.REACT_APP_SELLER_IMAGE_URL +
                        //   item?.videoThumbnail
                        // }
                        src={`${process.env.REACT_APP_SELLER_IMAGE_URL}upload/${item?.videoThumbnail}`}
                        alt={item?.title}
                      />
                    </div>

                    <div className="capitalize text-xs font-light tracking-wide p-3">
                      <div className="mb-2">
                        <span className="font-bold">Video: </span>
                        {item?.title}
                      </div>
                      {/* <div>
                        <span className="font-bold">Sku: </span>
                        {item?.sku || item?.monarchmart_sku}
                      </div> */}
                    </div>
                    <div
                      onClick={() => handleRemoveProductId(index)}
                      className="absolute -top-3 -right-3 z-30 bg-white text-red-500 rounded-full p-1 cursor-pointer shadow-lg"
                    >
                      <CloseIcon />
                    </div>
                  </div>
                );
              })}

              {choosenProducts.length === 0 && (
                <div className="flex items-center justify-center h-full">
                  <p className="text-gray-400 text-sm">No products added yet</p>
                </div>
              )}
            </div>

            {choosenProducts.length > 0 && (
              <>
                <div className={classes.BulkSkuPopup__footer}>
                  <p className="px-4 py-2 text-[0.8rem]">
                    Total videos: {choosenProducts.length}
                  </p>
                  {/* <ul className='flex gap'>
                    {products.map((product) => (
                      <li key={product._id}>{product.name}</li>
                    ))}
                  </ul> */}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* {showBulkPopup && (
        <BulkSkuPopup
          onClose={() => setShowBulkPopup(false)}
          onSetProducts={replaceProducts}
          onAddProducts={concatProducts}
        />
      )} */}
    </>
  );
};
